import { Box, Grid, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material'
import CategoryCard from './CategoryCard';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import {
    useHistory
} from "react-router-dom";
import { Category } from '@interfaces/caetgory';
import { IconByCategory } from './IconByCategory';

const MobileCategories = ({ category, onClick }: { category: Category, onClick: Function }) => {
    const labelId = `category-mobile-label-${category.id}`;
    return (
        <ListItem
            onClick={() => onClick(category.id)}
            style={{ backgroundColor: 'green', color: 'white' }}
            key={category.id}
            secondaryAction={
                <ArrowRightAltIcon />
            }
            disablePadding
        >
            <ListItemButton>
                <ListItemAvatar>
                    <IconByCategory category={category.name} />
                </ListItemAvatar>
                <ListItemText id={labelId} primary={category.name} />
            </ListItemButton>
        </ListItem>
    );
}
export const TokenCategories = ({ categories, selectedIndex }: { categories: Array<Category>, selectedIndex?: string }) => {
    let history = useHistory();

    const onClick = (index: string) => {
        history.push(`/browse-token/${index}`);
    }

    return (
        <div>
            <Box my={5}>
                <Typography gutterBottom variant="h5" component="div">
                    Browse by Category
                </Typography>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Grid container spacing={4} alignItems="center" justifyContent="space-between" flexWrap="wrap">
                    {categories.map(item => (
                        <Grid key={item.id} item md={2} xs={6} onClick={() => onClick(item.id)}>
                            <CategoryCard index={item.id} active={selectedIndex == item.id}>
                                <IconByCategory category={item.name} fontSize="large" />
                                <Typography variant="caption" gutterBottom>
                                    {item.name}
                                </Typography>
                            </CategoryCard>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                {categories.map(item => (
                    <> <MobileCategories category={item} onClick={(id: string) => onClick(id)} /> <br /> </>
                ))}
            </Box>
        </div >
    )
}
